/**
 * @desc 撤销预告公告
 */
import { AnnouncementBatchForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type WithdrawAnnouncementParameter = AnnouncementBatchForm

const method = 'PUT'
const url = '/trade/operation/announcement/withdraw'

export const withdrawAnnouncementApi = (
  data?: WithdrawAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

withdrawAnnouncementApi.method = method
withdrawAnnouncementApi.url = url
